<template>
  <el-dialog
    :title="titleName"
    :visible.sync="dialogVisible"
    width="1600px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
    top="10vh"
  >
    <div class="question-detail flex">
      <div class="top">
        <div class="reportRecords">上报记录</div>
        <div>
          <div v-for="(item, index) in formList.extendReportTaskList" :key="item.id">
            <div
              :class="['main-content', index == activeIndex ? 'main-content-active' : '']"
              @click.stop="detailClick(item, index)"
            >
              <div class="item">
                <div class="flex">
                  <div>
                    <img
                      class="imgPic"
                      v-if="JSON.parse(item.fileJson).length"
                      :src="JSON.parse(item.fileJson)[0].url"
                    />
                    <img
                      v-else
                      class="imgPic"
                      :src="require('@/assets/daping/imgPic.jpg')"
                    />
                  </div>
                  <div>
                    <div class="flex algin-center">
                      <div
                        class="name"
                        :title="item.eventName"
                        @click="detailClick(item, index)"
                      >
                        {{ item.eventName }}
                      </div>
                    </div>
                    <div class="disposition">
                      <!-- <img
                        v-if="item.state == '待分拨'"
                        :src="require('@/assets/image/wcz.svg')"
                      />
                      <img
                        v-if="item.state == '待认领'"
                        :src="require('@/assets/image/wcz.svg')"
                      />
                      <img
                        v-if="item.state == '已归档'"
                        :src="require('@/assets/image/wcz.svg')"
                      />
                      <img
                        v-if="item.state == '已办结'"
                        :src="require('@/assets/image/wcz.svg')"
                      />
                      <img
                        v-if="item.state == '已处置'"
                        :src="require('@/assets/image/ycz.svg')"
                      />
                      <img
                        v-if="item.state == '待处置'"
                        :src="require('@/assets/image/wcz.svg')"
                      /> -->
                      <img
                        v-if="item.transitionState202501 == '已处置'"
                        :src="require('@/assets/image/ycz.svg')"
                      />
                      <img
                        v-if="item.transitionState202501 == '未处置'"
                        :src="require('@/assets/image/wcz.svg')"
                      />
                    </div>
                    <div>
                      <div
                        class="content_tga"
                        v-for="itemList in listNumber"
                        :key="itemList.id"
                      >
                        <div class="left flex">
                          <img :src="itemList.img" alt="" class="mechanism" />

                          <div class="inspect_value flex">
                            <div style="margin: 0 12px">{{ itemList.name }}</div>

                            <div style="color: #e4f2ff">
                              {{ item[itemList.valueLi] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="right-bottom">
          <div class="tabs">
            <div class="tabs-box">
              <div
                class="tabs-item"
                :class="{ active: curTab == item.value }"
                v-for="(item, index) in tabsOptions"
                :key="index"
                @click="tabsChange(item)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="form-content">
            <div v-if="curTab == 1" style="margin: 24px 24px 0">
              <div class="right-top1" v-if="detailFormList.eventName">
                <div class="street">
                  <img
                    style="width: 50px; height: 50px"
                    :src="require('@/assets/daping/jssss.svg')"
                    alt=""
                  />
                  <div v-if="detailFormList.eventName" class="eventName">
                    {{ detailFormList.eventName }}
                  </div>
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <span style="margin-right: 12px">问题描述</span>
                  <span style="color: #e4f2ff">{{ detailFormList.taskDetail }}</span>
                </div>
              </div>
              <div class="flexCC">
                <div class="info-box">
                  <div class="info-box-item">
                    <span style="margin-right: 12px">上报人</span>
                    <span style="color: #e4f2ff">{{
                      detailFormList.reportUserName
                    }}</span>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <span style="margin-right: 12px">联系方式</span>
                    <span style="color: #e4f2ff">{{ detailFormList.reportUserTel }}</span>
                  </div>
                </div>
              </div>
              <div class="flexCC">
                <div class="info-box">
                  <div class="info-box-item">
                    <span style="margin-right: 12px">上报日期</span>
                    <span style="color: #e4f2ff">{{ detailFormList.reportTime }}</span>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <span style="margin-right: 12px">上报地点</span>
                    <span style="color: #e4f2ff">{{ detailFormList.reportAddress }}</span>
                  </div>
                </div>
              </div>
              <div class="flexCC">
                <div class="info-box">
                  <div class="info-box-item">
                    <span style="margin-right: 12px">主办单位</span>
                    <span style="color: #e4f2ff">{{
                      detailListForm.handleDeptName
                    }}</span>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-box-item">
                    <span style="margin-right: 12px">指派人员</span>
                    <span style="color: #e4f2ff">{{
                      detailListForm.handleUserName
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="info-box">
                <div class="info-box-item">
                  <span style="margin-right: 12px">现场照片</span>
                  <div class="keyPic">
                    <el-image
                      class="imgPic"
                      v-for="(itempic, index) in pointInfo.fileJsonZip"
                      :key="index"
                      :src="itempic"
                      :preview-src-list="pointInfo.fileJsonZip"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="curTab == 2">
              <div class="flex" v-if="detailList.length">
                <div class="fenbo">
                  <div
                    v-for="(item, index) in detailList"
                    @click="curClick(item, index)"
                    :key="index"
                    :class="['list', curTabIndex == index ? 'activeList' : '']"
                  >
                    <div class="flex">
                      <div class="handleDeptName">
                        {{ item.handleDeptName }}
                      </div>
                      <div :class="['assignType']">
                        {{ detailFormList.transitionState202501 }}
                      </div>
                    </div>
                    <div class="flex assignTime">
                      <div>{{ item.assignTime }} 分拨</div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">处置人</span>
                      <span>{{ detailListForm.handleUserName }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">处置时间</span>
                      <span>{{ detailListForm.handleTime }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">处置措施</span>
                      <span>{{ detailListForm.handleDetail }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">现场照片</span>
                      <div class="keyPic">
                        <el-image
                          class="imgPic"
                          v-for="(itempic, index) in detailListForm.handleFileJson"
                          :key="index"
                          :src="itempic.url"
                          :preview-src-list="detailListForm.handleFileJsonList"
                        >
                        </el-image>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="empty" v-else>
                <div style="text-align: center; margin-top: 50px">
                  <img src="@/assets/image/empty.png" alt="" />
                  <div style="font-size: 20px; color: #e4f2ff">暂无数据</div>
                </div>
              </div>
            </div>
            <div v-if="curTab == 3">
              <div
                class="flex"
                style="margin-left: 20px"
                v-if="detailHandleList.backUserName"
              >
                <div style="margin-top: 20px">
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">退回原因</span>
                      <span>{{ detailHandleList.backReason }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">退回人</span>
                      <span>{{ detailHandleList.backUserName }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">退回时间</span>
                      <span>{{ detailHandleList.backTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="empty" v-else>
                <div style="text-align: center; margin-top: 50px">
                  <img src="@/assets/image/empty.png" alt="" />
                  <div style="font-size: 20px; color: #e4f2ff">暂无数据</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import MapCom from "./mapCom.vue";
import { reportfullDetail } from "@/api/task.js";
export default {
  components: {
    MapCom,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    formList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tabsOptions: [
        {
          label: "上报详情",
          value: "1",
        },
        {
          label: "问题处置",
          value: "2",
        }
      ],
      detailHandleList: {},
      detailListForm: {},
      detailList: [],
      curTab: "1",
      curTabIndex: 0,
      pointInfo: {},
      processLi: process.env.VUE_APP_API_IMG_PATH,
      listNumber: [
        {
          name: "上报人",
          number: 5,
          img: require("@/assets/daping/ico-sbr.svg"),
          valueLi: "reportUserName",
        },
        {
          name: "上报日期",
          number: 5,
          img: require("@/assets/daping/ico-sj.svg"),
          valueLi: "reportTime",
        },
      ],
      detailFormList: {},
      activeIndex: 0,
      titleName: ''
    };
  },
  mounted() {
    this.detailFormList = this.formList.extendReportTaskList[0];
    this.titleName = '点位上报详情--' + this.detailFormList.pointName;
    this.getPicture(this.detailFormList);
    this.qusetionDetail(this.detailFormList);
  },
  watch: {
    formList: {
      handler(val) {
        this.detailFormList = val.extendReportTaskList[0];
        this.titleName = '点位上报详情--' + this.detailFormList.pointName;
        this.getPicture(this.detailFormList);
        this.qusetionDetail(this.detailFormList);
      },
      deep: true,
    },
  },
  methods: {
    getPicture(item) {
      this.pointInfo = item;
      if (!item.fileJson) {
        this.pointInfo.fileJsonZip = [];
      } else {
        let jsonList = JSON.parse(item.fileJson);

        this.pointInfo.fileJsonZip = jsonList.map((item) => {
          return item.url;
        });
      }
    },
    async qusetionDetail(item) {
      // 获取详情
      const res = await reportfullDetail({
        id: item.id,
      });
      if (res.data.code == 200) {
        this.detailHandleList = res.data.data;
        if (this.detailHandleList.backUserName) {
          this.tabsOptions = [
            {
              label: "上报详情",
              value: "1",
            },
            {
              label: "问题处置",
              value: "2",
            },
            {
              label: "退回说明",
              value: "3",
            },
          ];
        } else {
          this.tabsOptions = [
            {
              label: "上报详情",
              value: "1",
            },
            {
              label: "问题处置",
              value: "2",
            },
          ];
        }
        this.detailList = res.data.data.handleList;
        if (this.detailList.length > 0) {
          this.detailListForm = this.detailList && this.detailList[0];
          if (!this.detailListForm.handleFileJson) {
            this.detailListForm.handleFileJson = [];
            this.detailListForm.handleFileJsonList = [];
          } else {
            this.detailListForm.handleFileJson = JSON.parse(
              this.detailListForm.handleFileJson
            );
            this.detailListForm.handleFileJsonList = this.detailListForm.handleFileJson.map(
              (item) => item.url
            );
          }
        }
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    tabsChange(item) {
      this.curTab = item.value;
    },
    curClick(item, index) {
      this.detailListForm = item;
      this.curTabIndex = index;
      if (!this.detailListForm.handleFileJson) {
        this.detailListForm.handleFileJson = [];
      } else {
        this.detailListForm.handleFileJson = JSON.parse(this.detailList.handleFileJson);
      }
    },
    detailClick(item, index) {
      this.detailFormList = item;
      this.activeIndex = index;
      this.curTab = 1;
      this.getPicture(item);
      this.qusetionDetail(item);
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  background: url("~@/assets/daping/detail-bg.png") no-repeat;
  background-size: 100% 100%;
  height: 937px;
  .el-dialog__header {
    padding: 16px 30px 16px 24px;
    border: none;
  }
  .el-dialog__title {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 36px;
    color: #f3f8ff;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    background: linear-gradient(180deg, #ddefff 0%, #5bacef 100%);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
    margin-left: 50px;
  }
  .el-dialog__headerbtn {
    .el-dialog__close {
      font-size: 40px;
      color: #adc2d3;
    }
  }
}

/deep/.el-dialog__body {
  max-height: 830px !important;
  padding: 10px 20px;
}

/deep/.el-input {
  width: auto !important;
}
.flex {
  display: flex;
}
.flexCC {
  display: flex;
  .info-box {
    width: 35%;
  }
  .info-box:last-child {
    width: 65%;
  }
}
.flex-center {
  display: flex;
  justify-content: space-between;
}
.question-detail {
  height: calc(100% - 56px);
  border-radius: 8px 8px 0px 0px;

  .top {
    width: 500px;
    padding: 0 12px;
    height: 820px;
    overflow-y: auto;
    .reportRecords {
      font-weight: 500;
      font-size: 24px;
      color: #e4f2ff;
      margin: 10px 0 20px;
    }
  }
  .map-content {
    width: 400px;
    height: 224px;
    margin: 0 24px 0 0;
  }
}

.right-top1 {
  margin-bottom: 8px;
  padding: 0px 0 10px 0px;
  position: relative;
  flex: 1;

  .street {
    display: flex;
    align-items: center;
    font-family: MiSans, MiSans;
    font-weight: 500;
    font-size: 28px;
    color: #e4f2ff;
    position: relative;
    flex-wrap: wrap;
    .eventName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 28px;
      color: #e4f2ff;
      line-height: 40px;
    }
    .disposition {
      position: absolute;
      top: -10px;
      right: -10px;
      img {
        width: 120px;
        height: 120px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }
  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 20px;
      color: #adc2d3;
      line-height: 28px;
      margin-right: 54px;

      img,
      span {
        margin-right: 16px;
      }

      img {
        height: 18px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}
.bottom {
  flex: 1;
}
.right-bottom {
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 24px 8px;
    border-bottom: 1px solid rgba(70, 171, 255, 0.2);
    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 24px;
        color: #6e8095;
        margin-right: 48px;
        line-height: 32px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 500;
        color: #e4f2ff;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #46abff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  .info-box {
    margin-bottom: 24px;
    .info-box-item {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 20px;
      color: #adc2d3;
      line-height: 28px;
    }
  }
}

.keyPic {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .el-image {
    margin: 0 !important;
  }
  .imgPic {
    width: 240px;
    height: 240px;
    margin-right: 10px !important;
    border-radius: 6px;
    margin-bottom: 10px;
  }
}

.fenbo {
  width: 480px;
  margin: 20px 20px 0 24px;
  height: 740px;
  overflow-y: auto;

  .list {
    width: 460px;
    height: 88px;
    background: rgba(0, 163, 255, 0.1);
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;

      line-height: 28px;
      font-weight: 400;
      font-size: 20px;
      color: #e4f2ff;
    }
    .assignType {
      position: absolute;
      top: 0;
      right: 0;
      background: rgba(99, 218, 161, 0.2);
      border-radius: 0px 6px 0px 6px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #63daa1;
      line-height: 24px;
      padding: 2px 4px;
    }
    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #adc2d3;
      line-height: 22px;
    }
    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }
  .activeList {
    border: 1px solid;
    border-image: linear-gradient(270deg, rgba(70, 171, 255, 0), rgba(70, 171, 255, 1)) 1
      1;
  }
}

.main-content {
  .item {
    width: 480px;
    height: 170px;
    margin-bottom: 12px;
    color: #fff;
    background: radial-gradient(
        58% 78% at 0% 0%,
        rgba(0, 163, 255, 0.25) 0%,
        rgba(0, 163, 255, 0) 100%
      ),
      rgba(0, 163, 255, 0.05);
    border-radius: 4px;
    padding: 16px 20px;
    position: relative;
    .progress-list {
      width: 100%;
      height: 98px;
      background: linear-gradient(
        135deg,
        rgba(0, 163, 255, 0.1) 0%,
        rgba(0, 208, 255, 0.05) 100%
      );
      border-radius: 4px;
      margin-top: 6px;
      padding: 20px 24px;
      .circle {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .outCircle {
        width: 24px;
        height: 24px;
        border-radius: 12px;
        background-color: rgba(228, 242, 255, 0.2);
        padding: 6px;
      }
      .inCircle {
        width: 12px;
        height: 12px;
        border-radius: 6px;
        background-color: #adc2d3;
      }
      .guding {
        font-weight: 400;
        font-size: 16px;
        color: #6e8095;
        margin-top: 4px;
      }
      .gudingLiang {
        color: #e4f2ff;
      }
      .bianhua {
        font-weight: 400;
        font-size: 14px;
        color: #6e8095;
      }
      .kaishiCircle {
        .outCircle {
          background-color: rgba(0, 163, 255, 0.3);
        }
        .inCircle {
          background-color: #46abff;
        }
        .guding {
          color: #e4f2ff;
        }
      }
      .circleQueren {
        .outCircle {
          background-color: rgba(38, 223, 135, 0.28);
        }
        .inCircle {
          background-color: #26df87;
        }
        .guding {
          color: #e4f2ff;
        }
      }
      .line-list {
        width: 96px;
        height: 2px;
        background: rgba(110, 128, 149, 0.2);
        border-radius: 4px;
        margin-top: 12px;
      }
    }
    .daichuzhi {
      background: rgba(235, 90, 90, 0.2);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 12px;
      color: #eb5a5a;
      height: 16px;
      line-height: 16px;
      padding: 0 4px;
      margin: 0 12px;
    }
    .yichuzhi {
      background: rgba(99, 218, 161, 0.2);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 12px;
      color: #63daa1;
      height: 16px;
      line-height: 16px;
      padding: 0 4px;
      margin: 0 6px;
    }
    .name {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 24px;
      color: #e4f2ff;
      flex: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 20px;
    }
    .name:hover {
      color: #46abff;
      line-height: 24px;
    }
    .imgPic {
      width: 124px;
      height: 124px;
      border-radius: 6px;
    }
    .tongzhi {
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(0, 163, 255, 0) 0%,
        rgba(0, 163, 255, 0.3) 46%,
        rgba(0, 163, 255, 0) 100%
      );
      position: absolute;
      bottom: 0px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #01e8fe;
      line-height: 22px;
      align-items: center;
      padding: 7px 90px;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
}

.main-content-active,
.main-content:hover {
  .item {
    border: 1px solid #46abff;
    .name {
      color: #46abff;
      line-height: 24px;
    }
  }
}

.content_tga {
  margin: 7px 0 0 20px;
  .left {
    margin: 16px 0px;
  }
  .mechanism {
    width: 20px;
    height: 22px;
  }
  .inspect_value {
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #adc2d3;
  }
  .inspect_value_reportAddress {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.disposition {
  position: absolute;
  top: 10px;
  right: 10px;
  img {
    width: 65px;
    height: 54px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/centerItem/components/pointReportDetail.vue